import { TRUE } from "sass";

const pid = {
  key: "pid",
  title: "P&ID",
  angle: 40,
  summary: "Create and Connect P&ID's directly to all mView features.",
  releaseDate: "Late 2026",
  launch: "/",
  planStages: [
    {
      name: "Scoping documents",
      detail: [
        {
          text: "Concept feature",
          checked: true,
        },
        {
          text: "Business Systems Requirements Document (BSRD)",
          checked: true,
        },
        {
          text: "Functional Design Document (FDD)",
          checked: false,
        },
      ],
      completionDate: "Aug 26",
    },
    {
      name: "Development",
      detail: [
        {
          text: "Admin feature development & testing",
          checked: false,
        },
        {
          text: "Main feature development",
          checked: false,
        },
        {
          text: "Initial data entry (this is ongoing and will continue after initial release)",
          checked: false,
        },
        {
          text: "Development phase testing",
          checked: false,
        },
      ],
      completionDate: "Oct 26",
    },
    {
      name: "Testing & QA",
      detail: [
        {
          text: "Workflow documents production",
          checked: false,
        },
        {
          text: "Main feature testing",
          checked: false,
        },
        {
          text: "Training & support documentation production",
          checked: false,
        },
        {
          text: "Training and deployment",
          checked: false,
        },
      ],
      completionDate: "Dec 26",
    },
  ],
  points: [
    "Create P&ID's within integrated mView environment",
    "Create intelligent P&ID's that are based on standardised object data",
    "Automatically create documents and reports from P&ID's (e.g. line schedules, valve schedules, etc.)",
    "Direct link to 3D-models to highlight discrepancies within the data",
  ],
};

export default pid;
